import { useMediaQuery } from "@material-ui/core";
import { useTheme } from "@material-ui/core/styles";
import clsx from "clsx";
import { useRouter } from "next/router";
import { FC, useLayoutEffect, useState } from "react";

import { RouteName } from "@/consts/RouteName";
import { SettingMenuItem } from "@/features/section/components/setting/SettingMenuItem";
import { useSettingMenuItems } from "@/features/section/hooks/useSettingMenuItems";

type SettingMenuViewProps = {
  subMenuContainerClassName?: string;
  childrenContainerClassName?: string;
};

export const SettingMenuView: FC<SettingMenuViewProps> = ({
  subMenuContainerClassName = "shrink-0",
  childrenContainerClassName = "",
  children,
}) => {
  const theme = useTheme();
  const router = useRouter();
  const [top, setTop] = useState(0);
  const mdUp = useMediaQuery(theme.breakpoints.up("md"));
  const [openRoute, setOpenRoute] = useState(router.route);

  const isProfilePage = router.asPath === RouteName.MySettingsProfile;
  const items = useSettingMenuItems();

  useLayoutEffect(() => {
    const topBar = document.querySelector("#top-bar");
    if (!topBar) return;

    const height = topBar.getBoundingClientRect().height;
    setTop(height);
  }, [mdUp]);

  return (
    <div className="md:flex mt-8">
      {/* top + 40 = top bar + 40 margin (mt-10) */}
      <div
        className={clsx(
          "hidden md:block h-full w-60 mr-7 mb-10 rounded-md shadow-lg",
          isProfilePage ? "mt-0" : "mt-10",
          subMenuContainerClassName,
        )}
        style={{ top: top + 40 }}
      >
        {items.map((item, idx) => (
          <SettingMenuItem
            {...item}
            key={idx}
            isOpen={item.route === openRoute}
            setOpenRoute={(route: string) => {
              route === openRoute ? setOpenRoute(null) : setOpenRoute(route);
            }}
          />
        ))}
      </div>

      <div
        className={clsx(
          "flex-1 overflow-y-auto h-screen",
          childrenContainerClassName,
        )}
      >
        {children}
      </div>
    </div>
  );
};
